/*
 * Set içerik şeridinin yüksekliğini AKTİF slayta uydurur.
 *
 * SORUN (saha 2026-09-13): slaytlar tek bir flex satırında durduğu için şeridin
 * yüksekliği EN UZUN slayta kilitleniyor. Kısa bir slayt görüntülenirken metnin
 * altında kocaman boşluk kalıyor ve nokta göstergesi metinden çok uzağa düşüyor.
 * Ölçüldü: lip-vitamin-balm-set slaytları 495 / 529 / 547 / 659 karakter — yani
 * en kısa slaytta 659'luk slaytın yüksekliği kadar boşluk oluşuyordu.
 *
 * ÇÖZÜM: kaydırma konumundan aktif slayt bulunur ve şeridin yüksekliği o slaytın
 * yüksekliğine sabitlenir. Böylece noktalar her slaytta metnin hemen altında
 * kalır. Salt CSS ile çözülemiyor: yatay şeritte kapsayıcının yüksekliği tanım
 * gereği en uzun çocuğa göre belirlenir.
 *
 * Akordiyon KAPALIYKEN ölçüm yapılmaz (genişlik 0 olur, yükseklik yanlış çıkar);
 * açıldığında `toggle` olayıyla yeniden ölçülür.
 *
 * Bu dosya yüklenmezse şerit eski hâline döner: içerik doğru görünür, yalnız
 * kısa slaytlarda alt boşluk kalır. Yani işlevsel bir kayıp yoktur.
 */
(() => {
  const TRACK_SELECTOR = '.kremi-set-ingredients__track';

  const fitToActiveSlide = (track) => {
    const slides = track.children;
    // Akordiyon kapalıyken (genişlik 0) ölçme: yanlış yüksekliğe kilitlenir.
    if (!slides.length || !track.clientWidth) return;

    const index = Math.min(
      slides.length - 1,
      Math.max(0, Math.round(track.scrollLeft / track.clientWidth)),
    );
    const height = slides[index].offsetHeight;
    if (height > 0) track.style.height = `${height}px`;
  };

  const scheduleFit = (track) => {
    if (track.dataset.kremiFitPending === '1') return;
    track.dataset.kremiFitPending = '1';
    requestAnimationFrame(() => {
      track.dataset.kremiFitPending = '0';
      fitToActiveSlide(track);
    });
  };

  const setup = (track) => {
    if (track.dataset.kremiFitReady === '1') return;
    track.dataset.kremiFitReady = '1';

    track.addEventListener('scroll', () => scheduleFit(track), { passive: true });

    // Akordiyon açılıp kapandığında yeniden ölç (kapalıyken ölçüm geçersiz).
    track.closest('details')?.addEventListener('toggle', () => scheduleFit(track));

    // Yazı tipi geç yüklenirse ya da genişlik değişirse yükseklik kayar.
    if ('ResizeObserver' in window) {
      new ResizeObserver(() => scheduleFit(track)).observe(track);
    }

    scheduleFit(track);
  };

  const scan = () => document.querySelectorAll(TRACK_SELECTOR).forEach(setup);

  document.addEventListener('DOMContentLoaded', scan);
  // Bölüm yeniden çizildiğinde (tema editörü, sepet güncellemeleri) yeni şeritler.
  document.addEventListener('shopify:section:load', scan);
  // Varyanta bağlı içerik akordiyonu (variant-ingredients.js) içeriği olmayan varyantta
  // statik şeridi YENİDEN basar — o yeni şerit de ölçülsün (09-18, maske TRIO'su).
  document.addEventListener('kremi:ingredients:rendered', scan);
  scan();
})();
